/**
 * SR Free Shipping Bar (2026-09-17)
 *
 * Replaces the reward bar from the Essential Cart Drawer app. The Liquid
 * snippet renders the correct state on the server; this element only has to
 * cover cart mutations that do not re-render that snippet. Listens for the
 * theme's own 'cart:update' event and re-reads /cart.js.
 */
class SrFreeShipBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold || '3', 10) || 3;
    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener('cart:update', this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.onCartUpdate);
  }

  async onCartUpdate() {
    let count;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      count = (await res.json()).item_count;
    } catch {
      return;
    }
    if (typeof count !== 'number') return;
    this.render(count);
  }

  render(count) {
    const remaining = Math.max(this.threshold - count, 0);
    const pct = Math.min(Math.round((count / this.threshold) * 100), 100);
    const text = this.querySelector('[data-fsb-text]');
    const fill = this.querySelector('[data-fsb-fill]');
    if (text) {
      text.innerHTML = remaining
        ? `Add <strong>${remaining}</strong> more ${remaining === 1 ? 'item' : 'items'} to unlock <strong>free shipping</strong>!`
        : '<strong>Free Shipping</strong> unlocked!';
    }
    if (fill) fill.style.width = `${pct}%`;
    this.hidden = count === 0;
  }
}

if (!customElements.get('sr-free-ship-bar')) {
  customElements.define('sr-free-ship-bar', SrFreeShipBar);
}
